import { loadStripe } from "@stripe/stripe-js";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";

// This is loaded from environment config on the backend
// The backend returns the clientSecret which is environment-aware
const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ?? "",
);

export function StripeEmbeddedCheckout(props: {
  clientSecret: string;
  onComplete: () => Promise<void>;
}): JSX.Element {
  return (
    <EmbeddedCheckoutProvider
      stripe={stripePromise}
      options={{
        clientSecret: props.clientSecret,
        onComplete: props.onComplete,
      }}
    >
      <EmbeddedCheckout />
    </EmbeddedCheckoutProvider>
  );
}
